import { type ReactNode } from "react";

import { BTStatusBadge } from "@btnet/core-components";

import { BdsIconCheck, BdsIconClock, BdsIconXCircle } from "@buildertrend/components";

import { ApprovalStatus } from "commonComponents/approvals/ApprovalViewer/ApprovalViewer.types";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

export interface IApproverInfo {
    approverName: string;
    status: ApprovalStatus;
}

export interface IApproverColumn {
    approvers: IApproverInfo[];
}

type CellType = IApproverColumn | null;

const getStatusIcon = (status: ApprovalStatus): ReactNode | undefined => {
    switch (status) {
        case ApprovalStatus.Approved:
            return <BdsIconCheck />;
        case ApprovalStatus.Rejected:
            return <BdsIconXCircle />;
        case ApprovalStatus.Pending:
            return <BdsIconClock />;
        default:
            return undefined;
    }
};

const getStatusDisplayType = (status: ApprovalStatus) => {
    switch (status) {
        case ApprovalStatus.Approved:
            return "success";
        case ApprovalStatus.Rejected:
            return "danger";
        case ApprovalStatus.Pending:
            return "warning";
        default:
            return "default";
    }
};

const ApproversCell = ({ cellValue }: IGridCellRenderProps<CellType>) => {
    if (!cellValue || !cellValue.approvers || cellValue.approvers.length === 0) {
        return null;
    }

    return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
            {cellValue.approvers.map((approver, index) => (
                <BTStatusBadge
                    key={index}
                    testid={`badge-${approver.approverName}-${index}`}
                    text={approver.approverName}
                    displayType={getStatusDisplayType(approver.status)}
                    icon={getStatusIcon(approver.status)}
                />
            ))}
        </div>
    );
};

export const columnApprovers: IClientGridColumn<CellType> = {
    columnType: GridColumnType.approvers,
    Cell: ApproversCell,
};
